// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"40":"97e6e1ca","216":"913fe8e9","583":"13fd00f0","788":"3507a97c","966":"399b9ae8"}[chunkId] + ".chunk.js");